import { Dispatch } from "redux";
import {
  ERROR_LOADING_OBJECTS,
  GET_ALL_OBJECTS,
  RESET_DATA,
  START_LOADING_OBJECTS,
  STOP_LOADING_OBJECTS,
} from "./action-types";
import apiLibrary from "services/api";
import { generateQueryStringForUsers } from "utils/convertFiltersToQueryString";
import { Toasts } from "view/components/Toasts";

export const fetchObjectsAction =
  (communityId?: any) => async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: START_LOADING_OBJECTS });
    try {
      const currentState = getState();
      const params = generateQueryStringForUsers(
        currentState.Filters.objectsFilter
      );

      const query = appendCommunityIdInParams(communityId, params);

      const { data } = await apiLibrary.SpeciesAndObjects.getAllObjects(query);
      dispatch({
        type: GET_ALL_OBJECTS,
        payload: data,
      });
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);
      dispatch({
        type: RESET_DATA,
      });
      console.log("An error occurred while fetching the user profile:", error);
      dispatch({ type: ERROR_LOADING_OBJECTS });
      // dispatch(fetchError(error))
    } finally {
      dispatch({ type: STOP_LOADING_OBJECTS });
      // dispatch(loadingState(false))
    }
  };
const appendCommunityIdInParams = (communityId: any, params: any) => {
  let updatedParams = { ...params };

  if (communityId) {
    updatedParams.communityId = communityId.toString();
  }

  return updatedParams;
};

export const resetObjectsAction = () => {
  return {
    type: RESET_DATA,
  };
};
